import { render, staticRenderFns } from "./DamageRecord.vue?vue&type=template&id=dc912fce&scoped=true"
import script from "./DamageRecord.vue?vue&type=script&lang=js"
export * from "./DamageRecord.vue?vue&type=script&lang=js"
import style0 from "./DamageRecord.vue?vue&type=style&index=0&id=dc912fce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc912fce",
  null
  
)

export default component.exports